import { render, staticRenderFns } from "./AutoWidthInput.vue?vue&type=template&id=881f0332&scoped=true"
import script from "./AutoWidthInput.vue?vue&type=script&lang=js"
export * from "./AutoWidthInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881f0332",
  null
  
)

export default component.exports